import type { TEventColor } from '@/features/calendar/types'

const STORAGE_KEY = 'calendar-event-colors'

type StoredMap = Record<string, TEventColor>

const isBrowser = typeof window !== 'undefined'

function readStore(): StoredMap {
  if (!isBrowser) return {}

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return {}

    const parsed = JSON.parse(raw) as unknown
    if (parsed && typeof parsed === 'object') {
      return parsed as StoredMap
    }
    return {}
  } catch {
    return {}
  }
}

function writeStore(map: StoredMap) {
  if (!isBrowser) return

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map))
  } catch {
    // Ignore storage failures (e.g. private mode)
  }
}

export function getStoredEventColor(eventId?: number): TEventColor | undefined {
  if (typeof eventId !== 'number' || !Number.isFinite(eventId)) {
    return undefined
  }

  const store = readStore()
  return store[String(eventId)]
}

export function setStoredEventColor(eventId: number, color: TEventColor) {
  if (!Number.isFinite(eventId)) return

  const store = readStore()
  store[String(eventId)] = color
  writeStore(store)
}

export function removeStoredEventColor(eventId: number) {
  if (!Number.isFinite(eventId)) return

  const store = readStore()
  if (store[String(eventId)]) {
    delete store[String(eventId)]
    writeStore(store)
  }
}
